module.exports = {
    errorPane: 'final-error',
    onComplete: function (data, cb) {
        for (let key in data) {
            if (typeof (data[key]) !== "string") {
                data[key] = data[key].toString();
            }
        }
        data['lang'] = 'FR';
        data['source'] = 'SIMU_NOVEXX';
        //data['from_url'] = window.location.href;

        // TEST
        // const url = 'https://n8n.v1.yabawt.net/webhook-test/pipeline/novexx-v2';
        // PROD
        const url = 'https://webhook.n8n.yabawt.net/webhook/pipeline/novexx-v2';
        fetch(url, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }),
            body: JSON.stringify(data),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                cb(data.success);
            })
            .catch(error => {
                cb(false);
            });
    },
    backer: {
        content: '<< Retour'
    },
    breadcrumber: {
        stages: {
            '01': {},
            '02': {},
            '03': {},
            '04': {},
            '05': {},
            '06': {},
            '07': {},
        }
    },
    disableProgressBar: true,
    steps: [
        {
            crumbId: '01',
            title: "01. Pose d'étiquette",
            sub: "Sur quelle face de votre produit voulez-vous poser l'étiquette ?",
            btn: 'Continuer',
            gen: function (s) {
                s.Row()
                    .Selects({
                        class: 'flex-small type-icon',
                        name: 'label_product_face',
                        mode: 'unique',
                        autoNext: true,
                        choices: [
                            {
                                text: 'Côté',
                                img: './img/icon-side-new.png'
                            },
                            {
                                text: 'Dessus',
                                img: './img/icon-top.png'
                            },
                            {
                                text: 'Dessous',
                                img: './img/icon-down.png'
                            },
                            {
                                text: 'Dessus & Dessous',
                                img: './img/icon-top-down.png'
                            },
                            {
                                text: 'Enrobage (autour)',
                                img: './img/icon-coating.png'
                            },
                            {
                                text: 'Recto/Verso',
                                img: './img/icon-recto-verso.png'
                            },
                            {
                                text: 'Autres',
                                img: './img/icon-other.png'
                            }
                        ]
                    });
            }
        },
        {
            crumbId: '02',
            id: "label_print",
            title: "02. Impression d'étiquette",
            sub: "Voulez-vous imprimer la ou les étiquettes ? <small>(ex: repiquage de mention variables, DLUO, numéro de lot, code barre)</small>",
            btn: 'Continuer',
            gen: function (s) {
                s.Row()
                    .Selects({
                        class: 'flex-small type-icon',
                        name: 'print_label',
                        mode: 'unique',
                        autoNext: true,
                        choices: [
                            {
                                text: 'Oui',
                                val: 'true'
                            },
                            {
                                text: 'Non',
                                val: 'false'
                            },
                            {
                                text: 'Je ne sais pas',
                                val: 'ne sait pas'
                            },
                        ]
                    });
            },
            onShow: function (s) {
                gtmEvent({
                    'configurateur': 'gamme-mx',
                    'event': "step",
                    'title': "Pose d'etiquette",
                    'step': "1",
                    'data': s.engine.bag.get('label_product_face').value,
                });
            }
        },
        {
            crumbId: '03',
            id: 'solution',
            title: "03. Solution recherchée",
            sub: "Voulez vous un ensemble complet (convoyeur + étiqueteuse(s) ), juste l'étiqueteuse ou une autre solution ?",
            btn: 'Continuer',
            gen: function (s) {
                s.Row()
                    .Selects({
                        class: 'type-image flex-full',
                        name: 'solution',
                        mode: 'unique',
                        autoNext: true,
                        choices: [
                            {
                                text: 'Ensemble complet',
                                img: './img/produit-ensemble.png'
                            },
                            {
                                text: 'Etiqueteuse',
                                img: './img/produit-etiqueteuse.png'
                            },
                            {
                                text: 'Autres (logiciel, imprimante, consommables… )',
                                img: './img/produit-autres.png'
                            }
                        ]
                    });
            },
                onShow: function (s) {
                    gtmEvent({
                        'configurateur': 'gamme-mx',
                        'event': "step",
                        'title': "Impression d'etiquette",
                        'step': "2",
                        'data': s.engine.bag.get('print_label').value,
                    });
                }
        },
        {
            crumbId: '04',
            title: "04. Informations",
            sub: "Avez vous des informations particulières à nous communiquer concernant votre projet ?",
            btn: 'Continuer',
            gen: function (s) {
                s.Row()
                    .Textarea({
                        name: 'comment',
                        text: 'Commentaire (facultatif)',
                        optional: true,
                        placeholder: '(ex: machine en panne, remplacement du Parc Machine, nouvelle ligne… )'
                    })
            },
            onShow: function (s) {
                gtmEvent({
                    'configurateur': 'gamme-mx',
                    'event': "step",
                    'title': "Solution recherchée",
                    'step': "3",
                    'data': s.engine.bag.get('solution').value,
                });
            }
        },
        {
            crumbId: '05',
            title: "05. Contact",
            sub: "Pour recevoir votre proposition commerciale le plus rapidement possible, merci de renseigner les informations suivantes :",
            btn: {
                text: 'Valider',
                action: 'complete'
            },
            class: 'form-pane',
            gen: function (s) {
                s.Row()
                    .TextField({
                        name: 'lastname',
                        text: 'Nom *'
                    })
                    .TextField({
                        name: 'firstname',
                        text: 'Prénom *'
                    })
                s.Row()
                    .TextField({
                        name: 'company',
                        text: 'Société *'
                    })

                    .EmailField({
                        name: 'email',
                        text: 'Mail *'
                    })
                s.Row()
                    .PhoneField({
                        name: 'phone',
                        text: 'Téléphone *'
                    })
                    .TextField({
                        name: 'zipcode',
                        text: 'Code Postal*'
                    })
                s.Html({
                    html: '<div class="form-notice">*Informations obligatoires</div>'
                })
            },
            onShow: function (s) {
                gtmEvent({
                    'configurateur': 'gamme-mx',
                    'event': "step",
                    'title': "Informations",
                    'step': "4"
                });
            }
        },
        {
            title: "Votre demande est enregistrée.",
            sub: "Notre équipe commerciale se charge de traiter votre demande dans les plus brefs délais.",
            class: "last-pane pane-success",
            gen: function (s) {
                s.Html({
                    html: ''
                })
            },
            onShow: function (s) {
                gtmEvent({
                    'configurateur': 'gamme-mx',
                    'event': "step",
                    'title': "Contact",
                    'step': "5"
                });
            }
        },
        {
            id: 'final-error',
            title: "Une erreur est survenue.",
            sub: "Une erreur est survenue pendant la simulation. Veuillez réessayer plus tard.",
            class: "last-pane pane-error",
            gen: function (s) {
                s.Html({
                    html: ''
                })
            }
        }
    ]
};